<div class="tree-wrapper">
  <mat-radio-group>
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
      <!-- This is the tree node template for leaf nodes -->
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [matTreeNodePaddingIndent]="20">
        <!-- use a disabled button to provide padding for tree leaf -->
        <div class="custom-node" [class.custom-node--checked]="selectedNode && selectedNode.id == node.id">
          <ng-container *ngIf="node.type === NODE_TYPES.FEATURE">
            <ebw-monorepo-psa-feature-tree-element
              [node]="node"
              [selectedNode]="selectedNode"
              *ngIf="_psaService.isUrnReteIdrica(node.id) || _psaService.isUrnSchemaIdropotabile(node.id)"
              (onSelectedNodeFromRadioButton)="onSelectedNodeFromRadioButton($event)"
            >
            </ebw-monorepo-psa-feature-tree-element>

            <mat-radio-button
              *ngIf="!_psaService.isUrnReteIdrica(node.id) && !_psaService.isUrnSchemaIdropotabile(node.id)"
              [value]="node"
              color="primary"
              [checked]="selectedNode && selectedNode.id == node.id"
              (change)="onSelectedNodeFromRadioButton($event)"
            >
              <div class="d-flex flex-column align-items-start justify-content-center">
                <b>{{ node.name }}</b>
                <div *ngIf="_psaService.isUrnReteIdrica(node.id)" class="font-08rem">
                  {{ node.nodeData?.getProperties()?.original_dataset }}
                </div>
                <div *ngIf="_psaService.isUrnSchemaIdropotabile(node.id)" class="font-08rem">
                  {{ node.nodeData?.getProperties()?.tipologia }}
                </div>
              </div>
            </mat-radio-button>

            <button *ngIf="!simple" mat-icon-button [matMenuTriggerFor]="menu">
              <mat-icon>more_vert</mat-icon>
            </button>

            <mat-menu #menu="matMenu" class="feature-tree-menu">
              <button
                mat-menu-item
                class="w-100"
                *ngIf="node.nodeData['values_'].geometry"
                (click)="onNodeAction(node, 'highlight')"
              >
                <mat-icon class="me-1" color="accent">pin_drop</mat-icon>
                <span>Evidenzia sulla mappa</span>
              </button>

              <button mat-menu-item class="w-100" *ngIf="node.nodeData['values_'].geometry" (click)="onNodeAction(node, 'zoom-fit')">
                <mat-icon class="me-1" color="accent">zoom_in_fit</mat-icon>
                <span>Mostra sulla mappa</span>
              </button>

              <button
                mat-menu-item
                class="w-100"
                *ngIf="isAssetAllowedToDownloadKmzCircuiti(node.nodeData)"
                (click)="onNodeAction(node, 'kmz_circuiti')"
              >
                <mat-icon class="me-1" color="accent">download</mat-icon>
                <span>Export Percorso (.kmz)</span>
              </button>

              <button
                mat-menu-item
                *ngIf="isAssetAllowedToViewRaccordi(node.nodeData)"
                (click)="onNodeAction(node, 'raccordi')"
                matTooltip="Visualizzazione lista cavi di raccordo sala"
                matTooltipPosition="right"
              >
                <mat-icon class="me-1" color="accent">cable</mat-icon>
                <span>Gestione raccordi</span>
              </button>

              <button
                mat-menu-item
                *ngIf="isAssetAllowedToViewRaccordi(node.nodeData)"
                (click)="onNodeAction(node, 'cavo_raccordo')"
                matTooltip="Crea nuovo cavo di raccordo sala"
                matTooltipPosition="right"
              >
                <mat-icon class="me-1" color="accent">cable</mat-icon>
                <span>Nuovo cavo di raccordo</span>
              </button>
            </mat-menu>
          </ng-container>
        </div>
      </mat-tree-node>
      <!-- This is the tree node template for expandable nodes -->
      <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding [matTreeNodePaddingIndent]="20">
        <div class="custom-node">
          <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
            <mat-icon class="mat-icon-rtl-mirror">
              {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
            </mat-icon>
          </button>

          <mat-icon class="me-1" color="primary" *ngIf="node.type == NODE_TYPES.DATASET">dataset</mat-icon>
          <mat-icon class="me-1" color="primary" *ngIf="node.type == NODE_TYPES.COLLECTION">folder_open</mat-icon>
          <div class="node-label">{{ node.name }}</div>

          <button mat-icon-button [matMenuTriggerFor]="menuData">
            <mat-icon>more_vert</mat-icon>
          </button>

          <mat-menu #menuData="matMenu" class="feature-tree-menu">
            <button mat-menu-item class="w-100" (click)="onNodeAction(node, 'highlight')">
              <mat-icon class="me-1" color="accent">pin_drop</mat-icon>
              <span>Evidenzia elementi su mappa</span>
            </button>

            <button mat-menu-item class="w-100" (click)="onNodeAction(node, 'zoom-fit')">
              <mat-icon class="me-1" color="accent">zoom_in_fit</mat-icon>
              <span>Mostra sulla mappa</span>
            </button>
          </mat-menu>
        </div>
      </mat-tree-node>
    </mat-tree>
  </mat-radio-group>
</div>
